// packages import
import { memo } from "react";
import { CasesContainer } from "../../../containers/CasesContainer";

// Memoize the Cases component to prevent unnecessary re-renders when navigating back
export const Cases = memo((): JSX.Element => <CasesContainer />)